import styles from "./FooterPayments.module.scss";
export function FooterPayments() {
  return <div className={styles.payments} aria-label="iyzico, Visa, Mastercard">
    <img src="/assets/payments/iyzico.svg" alt="iyzico ile Öde" className={styles.iyzico} width="160" height="48" loading="lazy" />
    <img src="/assets/payments/visa.svg" alt="Visa" width="66" height="42" loading="lazy" />
    <img src="/assets/payments/master.svg" alt="Mastercard" width="66" height="42" loading="lazy" />
  </div>;
}
